import {Dropdown} from "react-bootstrap";
import {Link} from "react-router-dom";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import ImageComponent from "../shared/ImageComponent";
import NoImage from "../../../images/NoImage.jpg";
import NoProfile from "../../../images/profileImage.png";
import {getOfferStatusColor, offerStatusOptions} from "../../../utils/status";
import AttachedIcon from "../../../images/icons/attachedIcon";
import StarIcon from "../../../images/icons/starIcon";
import ZipCodeIcon from "../../../images/icons/zipCode";
import CategoryIcon from "../../../images/icons/CategoryIcon";
import AnnonceImageList from "../Annonce/ImageList";
import {useAddOffer} from "../../../hooks/useOffers";
import FavIcon from "../../../images/icons/favoriteIcon";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import {offerStatus} from "../../../utils/constants";
import {generatePrettyUrl} from "../../../utils/prettyUrl";
import CertainModal from "../shared/CertainModal";
import {useState} from "react";
import {getDateLocale} from "../../../utils/date";

export const OfferCard = ({offer, client, ...props}) => {
  const categories = Array.from(
    new Set(offer?.SubCategories.map((el) => el?.Category?.title)),
  );

  const {bg, color} = getOfferStatusColor({status: offer?.status});

  return (
    <div className=" w-full flex p-3 gap-6 border-2 rounded-2xl border-solid relative">
      <div className="min-w-[280px] w-1/4 ">
        <ImageComponent
          src={buildImageUrl(offer?.FileUploads[0]?.path)}
          alt=""
          className=" w-[277px] h-[277px] object-cover rounded-xl"
          width="130"
          fallback={
            <img
              src={NoProfile}
              alt=""
              className=" w-[277px] h-[277px] object-cover  rounded-xl"
              width="130"
            />
          }
        />
      </div>
      <div className="absolute top-5 right-5 flex gap-2 justify-center">
        {!!offer?.FileUploads[0]?.path && (
          <div className="w-8 h-8 rounded-full bg-[#EFF2F7] flex justify-center items-center ">
            <AttachedIcon className="w-4 h-4" />
          </div>
        )}
        <div className="w-8 h-8 rounded-full bg-[#EFF2F7] flex justify-center items-center ">
          <StarIcon className="w-4 h-4" />
        </div>
      </div>

      <div className="w-3/4 flex flex-col justify-between ">
        <div className="w-full flex flex-col justify-start">
          {/*         section title
           */}{" "}
          <div className="fs-20 flex items-center justify-start gap-2 font-w500 mb-2 w-4/5">
            <Link
              data-i18n-skip
              to={"annonce/" + generatePrettyUrl(offer?.id, offer?.title)}
              className="text-[#19295C] w-auto font-bold text-[24px] capitalize-first line-clamp-1 "
            >
              {offer?.title}
            </Link>
            <div
              className="w-[0.75rem] h-[0.75rem] min-w-[0.75rem] rounded-full flex-shrink-0"
              style={{backgroundColor: color}}
            ></div>
          </div>
          {/* section date
           */}{" "}
          <div className="flex items-center justify-start gap-6 mb-4">
            <div className="text-dark text-[14px] text-nowrap">
              <i className="fa fa-calendar-o mr-3" aria-hidden="true"></i>

              {new Date(offer?.pub_Date ?? offer?.createdAt).toLocaleDateString(
                getDateLocale(),
                {
                  weekday: "long", // jour de la semaine
                  year: "numeric", // année
                  month: "long", // mois en toutes lettres
                  day: "numeric", // jour du mois
                },
              )}
            </div>
            <div className=" text-primary font-semibold text-[16px] flex items-center gap-3">
              {offer?.minBudget}€ - {offer?.maxBudget}€{" "}
            </div>
          </div>
          {/* section details  */}
          <div className="flex flex-col gap-3 justify-start w-full mb-3">
            <div className="flex justify-start gap-2 w-full">
              <div className="w-2/5">
                <span className="mb-0 font-medium text-base title">Statut</span>{" "}
                :
                <span className="text-[#19295C] font-medium ml-2">
                  {
                    offerStatusOptions.find((el) => el.value === offer?.status)
                      .label
                  }
                </span>
              </div>
              <div className="w-3/5">
                <span className="mb-0 font-medium text-base title">
                  Adresse
                </span>{" "}
                :
                <span className="text-[#19295C] font-medium desc-text ml-2">
                  {!!offer?.address ? offer?.address : "--"}
                </span>
              </div>
            </div>
            <div className="flex justify-start gap-2 w-full">
              <div className="w-2/5  ">
                <span className="mb-0 font-medium text-base title">
                  Catégories :{" "}
                </span>
                {!!categories.length
                  ? categories?.map((ele) => (
                      <span className="text-[#19295C] font-medium ml-2">
                        {ele ?? "--"}
                      </span>
                    ))
                  : "  --"}
              </div>
              <div className="w-3/5">
                <span className="mb-0 font-medium text-base title">
                  Sous-Catégories :{" "}
                </span>
                {!!offer?.SubCategories?.length
                  ? offer?.SubCategories?.map((ele) => (
                      <span className="text-[#19295C] font-medium ml-2">
                        {ele?.title ?? "--"}
                      </span>
                    ))
                  : "  --"}
              </div>
            </div>
          </div>
          {/* section description  */}
          <div className="w-full line-clamp-2">
            <span className="mb-0 font-medium text-base title ">
              Description :{" "}
            </span>
            <span data-i18n-skip className=" font-medium text-[15px] text-[#19295C] ">
              {offer?.description}
            </span>
          </div>
        </div>
        <div className=" min-w-[140px] w-full sm:w-[140px] mt-3  ">
          <Link to={"annonce/" + generatePrettyUrl(offer?.id, offer?.title)}>
            <button className="btn !p-0 w-full h-[40px]  rounded-lg !text-[14px] flex justify-center items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white ">
              Voir plus
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

// export default OfferCard;

export const OfferCardTech = ({offer, technicianID, listFav}) => {
  const {bg, color} = getOfferStatusColor({status: offer?.status});
  const label = offerStatusOptions.find(
    (el) => el.value === offer?.status,
  )?.label;
  const {onAddFavorite, onRemoveFavorite} = useAddOffer();

  return (
    <div
      title={label}
      className="w-full p-6 flex flex-col gap-[14px] overflow-hidden relative bg-white rounded-2xl border border-solid border-[#E2E2E2] "
    >
      <div className=" h-[67px]   absolute top-0 right-0 flex justify-end items-center ">
        {!!technicianID && (
          <div className="flex justify-center items-center m-2 p-2 w-8 h-8 bg-[#EFF2F7] text-lg rounded-full text-[#FF6600] cursor-pointer">
            {listFav ||
            !!offer?.technicianFavorite?.find(
              (tech) => tech?.id === technicianID,
            ) ? (
              <FavIcon
                onClick={() => {
                  onRemoveFavorite({id: offer?.id});
                }}
                className="w-4 h-4 fill-[#FF6600]"
              />
            ) : (
              <i
                onClick={() => {
                  onAddFavorite({id: offer?.id});
                }}
                class="fi fi-rr-star flex items-center"
              ></i>
            )}
          </div>
        )}
        <div className="w-[67px] rounded-bl-full h-full bg-[#FFF0E7] p-3 flex justify-end items-start">
          <ImageComponent
            src={buildImageUrl(
              offer?.SubCategories[0]?.Category?.Sector?.imagePath,
            )}
            alt="secteur"
            title={offer?.SubCategories[0]?.Category?.Sector?.title}
            className=" w-6 "
            fallback={
              <img
                src={NoImage}
                alt=""
                className=" w-6"
                width="130"
                title={offer?.SubCategories[0]?.Category?.Sector?.title}
              />
            }
          />
        </div>
      </div>
      <div className="flex items-start justify-start gap-3 !mt-8 sm:!mt-0 ">
        <Link
          to={"/client/" + offer?.Client?.id}
          className="relative min-w-11 w-11"
        >
          {!!offer?.Client?.User?.avgRating && (
            <div className="bg-[#FFC107] w-[30px] flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[7px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] ">
              {Number(offer?.Client?.User?.avgRating).toFixed(2)}
              <StarIcon className="fill-white stroke-none w-2 h-2" />
            </div>
          )}
          <ImageComponent
            src={buildImageUrl(offer?.Client?.User?.imageUri)}
            alt=""
            className=" w-11 h-11 min-w-11 rounded-full object-cover"
            fallback={
              <img
                src={NoProfile}
                alt=""
                className=" w-11 h-11 min-w-11 rounded-full object-cover"
                width="130"
              />
            }
          />
        </Link>
        <div className="flex flex-col justify-center items-start">
          <span className="text-[#19295C] font-bold text-base capitalize">
            {offer?.Client?.User?.lastName +
              " " +
              offer?.Client?.User?.firstName}
          </span>
          <div className="flex items-center justify-start gap-2 flex-wrap ">
            <div className="text-dark flex flex-nowrap gap-2 text-[14px] text-nowrap mr-[10px]">
              <i className="fi fi-rr-calendar flex items-center"></i>
              {new Date(offer?.pub_Date ?? offer?.createdAt).toLocaleDateString(
                getDateLocale(),
                {
                  weekday: "short", // jour de la semaine
                  year: "numeric", // année
                  month: "short", // mois en toutes lettres
                  day: "numeric", // jour du mois
                },
              )}
            </div>
            <div className=" text-primary font-semibold text-[16px] flex items-center gap-1 text-nowrap mr-[100px]">
              <i className="fi fi-rr-coins flex items-center"></i>
              {offer?.minBudget}€ - {offer?.maxBudget}€{" "}
              <span className="text-[#7E7E7E] text-[12px] ml-1 font-medium text-nowrap">
                ({offer?.viewCount ?? 0} vues)
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="fs-20 flex items-center justify-start  font-w500  w-full line-clamp-1">
        <Link
          data-i18n-skip
          title={offer?.title}
          to={"annonce/" + generatePrettyUrl(offer?.id, offer?.title)}
          className="text-[#19295C]  font-semibold text-[18px]  capitalize-first line-clamp-1  "
        >
          {offer?.title}
        </Link>
        <div className="w-5 flex justify-center items-center">
          <div
            className="w-[0.75rem] h-[0.75rem] min-w-[0.75rem] rounded-full flex-shrink-0"
            style={{backgroundColor: color}}
          >
            {" "}
          </div>
        </div>
      </div>
      <div className="flex w-full justify-start items-center gap-4">
        <div className="flex justify-start items-center gap-2  text-[#7E7E7E] font-bold text-[15px]">
          <ZipCodeIcon className="w-4 h-4 fill-[#1A64B9]" />{" "}
          {offer?.postCode ?? "--"}
        </div>
        <div className="flex justify-start items-center gap-2  text-[#7E7E7E] font-bold text-[15px]">
          <CategoryIcon className="w-4 h-4 fill-[#1A64B9]" />{" "}
          {offer?.SubCategories[0]?.Category?.title ?? "--"}
        </div>
      </div>
      <div className="flex w-full  gap-2 justify-start items-start font-medium text-[16px] text-[#1A64B9]   ">
        <i className="fi fi-rr-info mt-[2px]"></i>{" "}
        <div data-i18n-skip className="text-[#7e7e7e] text-[15px] line-clamp-2 leading-5">
          {offer?.description ?? "--"}
        </div>
      </div>

      <div className="flex w-full flex-col sm:flex-row justify-between items-end">
        <AnnonceImageList offer={offer} />
        <div className=" min-w-[140px] w-full sm:w-[140px] mt-2  ">
          <Link
            className=""
            to={"/annonce/" + generatePrettyUrl(offer?.id, offer?.title)}
          >
            <button className="btn !p-0 w-full h-[40px]  rounded-lg !text-[14px] flex justify-center items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white ">
              Voir plus
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export const OfferCardClient = ({offer, chatrooms}) => {
  const {bg, color} = getOfferStatusColor({status: offer?.status});
  const [isOpen, setIsOpen] = useState(false);
  const label = offerStatusOptions.find(
    (el) => el.value === offer?.status,
  )?.label;
  const {onDeleteOffer, onUpdateOffer, onActivateOffer, onHideOffer} =
    useAddOffer();

  return (
    <>
      <CertainModal
        title={"Supprimer annonce"}
        message={`Êtes-vous sûr de vouloir supprimer l'annonce intitulé "${offer?.title}"?`}
        show={isOpen}
        setShow={setIsOpen}
        handelButton={() => {
          onDeleteOffer({id: offer?.id});
        }}
      />
      <div
        title={label}
        className={`w-full p-6 flex flex-col gap-2 overflow-hidden relative  rounded-2xl border-[1px] border-solid   ${
          offer?.status === offerStatus.ENDED
            ? "bg-[#f7f7f7] !border-[#d6d6ff]"
            : "bg-white !border-[#E2E2E2]"
        }`}
      >
        <div className=" !px-6 !py-3 gap-5 z-10 absolute top-0 right-0 flex justify-end items-center ">
          {!!chatrooms?.length ? (
            <Link to={"/messages#" + chatrooms[0]?.id}>
              <div className="relative bg-[#EFF2F7] w-8 h-8 rounded-full flex justify-center items-center text-[#1A64B9] text-base ">
                <i className="fi fi-rr-paper-plane flex items-center"></i>
                {!!chatrooms?.length && (
                  <div class="absolute bg-[#FF6600] text-white text-[8px] font-semibold flex items-center justify-center rounded-full w-[13px] h-[13px] -top-1 -right-1 ">
                    {chatrooms.length}
                  </div>
                )}
              </div>
            </Link>
          ) : (
            <div className="relative bg-[#EFF2F7]  w-8 h-8 rounded-full flex justify-center items-center text-[#1A64B9] text-base ">
              <i className="fi fi-rr-paper-plane flex items-center"></i>
            </div>
          )}

          <Dropdown>
            <DropdownToggle
              variant=""
              className=" i-false !p-0 font-bold text-lg "
            >
              <i className="fi fi-rr-menu-dots-vertical flex items-center"></i>{" "}
            </DropdownToggle>
            <DropdownMenu
              align="right"
              className="mt-2 w-[150px] p-0 !rounded-md "
            >
              {[
                offerStatus.PUBLIC,
                offerStatus.VALIDATION_WAITING,
                offerStatus.DISALLOW,
              ].includes(offer?.status) && (
                <Dropdown.Item className="cursor-pointer dropdown-item group    !px-4 border-b font-semibold hover:bg-[#EFF2F7]">
                  <Link
                    to={"annonce/modifier-annonce/" + offer?.id}
                    className="  text-[#3D4465] hover:text-[#3D4465] text-sm"
                  >
                    Modifier
                  </Link>
                </Dropdown.Item>
              )}
              {[offerStatus.PUBLIC].includes(offer?.status) && (
                <Dropdown.Item
                  className="cursor-pointer dropdown-item group    !px-4 !text-[#3D4465] !text-sm font-semibold hover:text-[#FF6600] hover:bg-[#EFF2F7]"
                  onClick={() =>
                    onHideOffer({
                      id: offer?.id,
                    })
                  }
                >
                  Désactiver
                </Dropdown.Item>
              )}
              {[offerStatus.DISABLED].includes(offer?.status) && (
                <Dropdown.Item
                  className="cursor-pointer dropdown-item group    !px-4 !text-[#3D4465] !text-sm font-semibold hover:text-[#FF6600] hover:bg-[#EFF2F7]"
                  onClick={() =>
                    onActivateOffer({
                      id: offer?.id,
                    })
                  }
                >
                  Activer
                </Dropdown.Item>
              )}
              <Dropdown.Item
                onClick={() => {
                  setIsOpen(true);
                }}
                className="cursor-pointer dropdown-item group    !px-4 !text-[#3D4465] !text-sm border-b font-semibold hover:text-[#FF6600] hover:bg-[#EFF2F7]"
              >
                Supprimer
              </Dropdown.Item>
            </DropdownMenu>
          </Dropdown>
        </div>

        <div
          className={`flex flex-col gap-2 w-full ${
            offer?.status === offerStatus.DISABLED
              ? "filter brightness-80 opacity-60"
              : ""
          }`}
        >
          <div className="text-lg flex items-center justify-start max-w-[70%]  font-medium mt-2  w-full ">
            <Link
              data-i18n-skip
              title={offer?.title}
              to={"annonce/" + generatePrettyUrl(offer?.id, offer?.title)}
              className="text-[#19295C]  font-semibold text-[18px]  capitalize-first truncate  "
            >
              {offer?.title}
            </Link>
            <div className="w-5 flex justify-center items-center">
              <div
                title={label}
                className="w-[0.75rem] h-[0.75rem] min-w-[0.75rem] rounded-full flex-shrink-0"
                style={{backgroundColor: color}}
              >
                {" "}
              </div>
            </div>
          </div>

          <div className="flex items-center justify-start gap-2 flex-wrap ">
            <div className="text-dark flex flex-nowrap gap-2 text-[14px] text-nowrap mr-[10px]">
              <i className="fi fi-rr-calendar flex items-center"></i>

              {new Date(offer?.pub_Date ?? offer?.createdAt).toLocaleDateString(
                getDateLocale(),
                {
                  weekday: "short", // jour de la semaine
                  year: "numeric", // année
                  month: "short", // mois en toutes lettres
                  day: "numeric", // jour du mois
                },
              )}
            </div>
            <div className=" text-primary font-semibold text-[16px] flex items-center gap-3 text-nowrap mr-[100px]">
              {offer?.minBudget}€ - {offer?.maxBudget}€{" "}
              <span className="text-[#7E7E7E] text-[12px] font-medium text-nowrap">
                ({offer?.viewCount ?? 0} vues)
              </span>
            </div>
          </div>
          <div className="flex w-full justify-start items-center flex-wrap gap-4">
            <div className="bg-[#F1F2F7] rounded-sm   flex !px-[8px] !py-[3px] gap-2 justify-center items-center text-xs font-semibold text-[#19295C]">
              <ImageComponent
                src={buildImageUrl(
                  offer?.SubCategories[0]?.Category?.Sector?.imagePath,
                )}
                alt="secteur"
                title={offer?.SubCategories[0]?.Category?.Sector?.title}
                className="w-[1.75rem] aspect-square object-contain"
                fallback={
                  <img
                    src={NoImage}
                    alt=""
                    className="w-[1.75rem] aspect-square object-contain"
                    width="130"
                    title={offer?.SubCategories[0]?.Category?.Sector?.title}
                  />
                }
              />
              <span>{offer?.SubCategories[0]?.Category?.Sector?.title}</span>
            </div>
            <div className="flex justify-start items-center gap-2  text-[#7E7E7E] font-bold text-xs">
              <CategoryIcon className="w-3 h-3 fill-[#1A64B9]" />{" "}
              {offer?.SubCategories[0]?.Category?.title ?? "--"}
            </div>
          </div>
          <div className="flex w-full  gap-2 justify-start items-start font-medium text-[16px] text-[#1A64B9]   ">
            <i className="fi fi-rr-info mt-[2px]"></i>{" "}
            <div data-i18n-skip className="text-[#7e7e7e] text-[15px] line-clamp-2 leading-5">
              {offer?.description ?? "--"}
            </div>
          </div>

          <div className="flex w-full flex-col sm:flex-row justify-between items-end">
            <AnnonceImageList offer={offer} />
            <div className=" min-w-[140px] w-full sm:w-[140px] mt-2  ">
              <Link
                className=""
                to={"/annonce/" + generatePrettyUrl(offer?.id, offer?.title)}
              >
                <button className="btn !p-0 w-full h-[40px]  rounded-lg !text-[14px] flex justify-center items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white ">
                  Voir plus
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
